<template>
    <div class="wrapper options pink">
        <div class="mycontent">

          <h2 data-aos="fade-up" data-aos-delay="0" data-aos-offset="0">{{ Video.title }}</h2>

          <div class="block-video-1" data-aos="fade-up" data-aos-delay="500" data-aos-duration="700" data-aos-offset="0">
            <div class="block-in jet-vid">
               <iframe width="560" height="315" :src="`${dataID}`" title="YouTube video player" frameborder="0" 
               allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </div>
          </div>

      </div>
    </div>
</template>

<script>
let lang = process.env.VUE_APP_LOCALITY;
import Content from "../data/content";

export default {
    name: 'Video',
    data: function() {
        return {
          Video: Content[lang].video,
          dataID: Content[lang].video.id,
        }
    }
}
</script>

<style lang="scss">
.options {
  position: relative;
  z-index: 99;
  margin: 0;
  padding: 70px 15px 85px;
  text-align: center;
  border-radius: 50px 50px 0 0;
}
.options h2 {
  padding: 0 0 60px 0;
}
.options p {
  white-space: break-spaces;
}
.options h4 {
  text-align: center;
  color: #ff8000;
}
.block-video-1 {
  margin-bottom: 70px;
}
.options p {
  max-width: 700px;
  margin: 0 auto 24px;
}

@media only screen and (max-width :1023px){
  .options {
    h2 {
      font-size: 20px;
      line-height: 130%;
      padding: 0 0 30px 0;
    }
  }
}
</style>